import {
  REQUEST_EXISTANT_CLAIMS,
  SET_EXISTANT_CLAIMS,
  REQUEST_VALIDATE_EXISTING_CLAIM__DOCUMENTS,
} from 'containers/ManagerDocumentsPage/constants';
import { Document } from 'containers/ManagerDocumentsPage/typings';

export const requestExistantClaims = (
  status: string,
  page: number,
  pageSize: number,
) => ({
  type: REQUEST_EXISTANT_CLAIMS,
  status,
  page,
  pageSize,
});

export const setExistantClaims = (existantClaims: any) => ({
  type: SET_EXISTANT_CLAIMS,
  existantClaims,
});

export const requestValidateExistingClaimDocuments = (
  documents: Document[],
) => ({
  type: REQUEST_VALIDATE_EXISTING_CLAIM__DOCUMENTS,
  documents,
});
